import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from 'react-toastify';
import { useUser } from '../context/UserContext';
import { useLocation } from "react-router-dom";
import { useRef, useEffect } from "react";
import { useToastFromNavigation } from '../hooks/useToastFromNavigation';


export default function AuthForm() {
  const [isLogin, setIsLogin] = useState(true);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    business_name: "",
    phone: ""
  });
  
  const { setUser } = useUser();
  const [message, setMessage] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();


    // ✅ Κλήση του hook εδώ
  useToastFromNavigation();

  

  const toggleForm = () => {
    setIsLogin(!isLogin);
    setFormData({ name: "", email: "", password: "", business_name: "", phone: "" });
    setMessage("");
  };

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  const payload = isLogin
    ? {
        email: formData.email,
        password: formData.password,
         rememberMe: rememberMe,
      }
    : formData;

const API = process.env.REACT_APP_API_BASE_URL || 'https://python.remindly.gr';

const url = isLogin
  ? `${API}/auth/login`
  : `${API}/auth/register`;

  try {
    const res = await axios.post(url, payload);
    console.log("✅ Success:", res.data);

if (isLogin && res.data.success) {
  localStorage.setItem("token", res.data.token); // ──▶ ADD THIS LINE
  setUser(res.data.user);

  toast.success("Επιτυχής σύνδεση! Μεταφορά στο ημερολόγιο...", {
    autoClose: 2500,
  });

  setTimeout(() => {
    navigate("/calendar");
  }, 2500);
}
 else {
      toast.success("🎉 Εγγραφή επιτυχής!");
    }
  } catch (err) {
    console.error("Login error:", err.response?.data);
    toast.error("Σφάλμα: " + (err.response?.data?.error || "Κάτι πήγε στραβά."));
  }
};



  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="bg-white p-8 rounded-2xl shadow-md w-full max-w-md">
        <h2 className="text-2xl font-bold mb-6 text-center">
          {isLogin ? "Σύνδεση" : "Εγγραφή"}
        </h2>

 

        <form onSubmit={handleSubmit} className="space-y-4">
          {!isLogin && (
            <>
              <input
                type="text"
                name="name"
                placeholder="Ονοματεπώνυμο"
                value={formData.name}
                onChange={handleChange}
                className="w-full p-2 border rounded-md"
                required
              />
              <input
                type="text"
                name="business_name"
                placeholder="Όνομα επιχείρησης"
                value={formData.business_name}
                onChange={handleChange}
                className="w-full p-2 border rounded-md"
                required
              />
              <input
                type="text"
                name="phone"
                placeholder="Τηλέφωνο"
                value={formData.phone}
                onChange={handleChange}
                className="w-full p-2 border rounded-md"
              />
            </>
          )}

          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            className="w-full p-2 border rounded-md"
            required
          />
          <input
            type="password"
            name="password"
            placeholder="Κωδικός"
            value={formData.password}
            onChange={handleChange}
            className="w-full p-2 border rounded-md"
            required
          />


<label className="flex items-center gap-2 text-sm mt-3">
  <input
    type="checkbox"
    checked={rememberMe}
    onChange={(e) => setRememberMe(e.target.checked)}
  />
  Να μείνω συνδεδεμένος
</label>


          <button
            type="submit"
            className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-md"
          >
            {isLogin ? "Είσοδος" : "Δημιουργία Λογαριασμού"}
          </button>
        </form>

        <div className="mt-4 text-sm text-center">
          {isLogin ? (
            <>
              Δεν έχεις λογαριασμό;{" "}
              <button onClick={toggleForm} className="text-blue-600 underline">
                Εγγραφή
              </button>
            </>
          ) : (
            <>
              Έχεις ήδη λογαριασμό;{" "}
              <button onClick={toggleForm} className="text-blue-600 underline">
                Σύνδεση
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
